import 'react-tagsinput/react-tagsinput.css'; // If using WebPack and style-loader.
import {
  getAllPatients,
  getPatientByTag,
  getPatientDetailsById,
  getPatientMasterTags,
  getPatients,
  getPatientsByFilter, getPatientsByFirstCharacter, newPatient,
} from './actions/PatientActions';
// import { getMasterData } from '../Dashboards/actions/StaffDashboardActions';
import { showFormatedDate, base64Encode, base64Decode } from '../../actions/utilAction';
import { change, Field, reduxForm } from 'redux-form';
import { List, ListItem } from 'material-ui/List';
import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import Avatar from 'material-ui/Avatar';
// import avatar from '../../img/uxceo-128.jpg';
// import CircularProgress from 'material-ui/CircularProgress';
import { connect } from 'react-redux';
import SmallLoader from '../../img/small-loader.gif';
import { NavLink } from 'react-router-dom';
import {
  renderAutoCompleteMultipleSelection, renderCheckBox,
} from '../../components/reduxFields';
// import TagsInput from 'react-tagsinput';
// import user1 from '../../img/noimage.png';
import history from '../../history';

const stylescss = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
};

// const selectedObj = {};
class ListPatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChar: '',
      tags: [],
      patientdata: [],
      searchType: 'GET_TRUE',
      openAdvanceSearch: false,
      ActiveClient: false,
      InactiveClient: false,
      searchTerm: '',
      type: 'GET_ALL',
      ShowClientsOfAllLocations: false,
      // selectedObj: { id: 1, label: 'test', value: 'test' },
    };
    this.onClickAlphabet = this.onClickAlphabet.bind(this);
    this.renderPatients = this.renderPatients.bind(this);
    this.getPatientById = this.getPatientById.bind(this);

    // this.handleDelete = this.handleDelete.bind(this);
    // this.handleAddition = this.handleAddition.bind(this);
    // this.handleDrag = this.handleDrag.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.hideSidebar = this.hideSidebar.bind(this);
    this.onPatientClick = this.onPatientClick.bind(this);
    this.handleAdvanceSearchClick = this.handleAdvanceSearchClick.bind(this);

  }

  // loadPatients(filter, searchText, type) {
  //   if (type) {
  //     this.setState({ searchType: type });
  //   } else {
  //     type = this.state.searchType;
  //   }

  //   if (type === 'GET_ALL') {
  //     this.props.getPatientsByFirstCharacter(filter, searchText, '');
  //   } else if (type === 'GET_TRUE') {
  //     let advancedFilter = '&filter[isactive]=true';
  //     this.props.getPatientsByFirstCharacter(filter, searchText, advancedFilter);
  //   } else {
  //     let advancedFilter = '&filter[isactive]=false';
  //     this.props.getPatientsByFirstCharacter(filter, searchText, advancedFilter);
  //   }
  // }

  loadPatients() {
    let type = this.state.type;
    let searchObj = {};
    if (type === 'GET_FALSE') {
      this.setState({ prevType: this.state.searchType });
    }
    if (type) {
      this.setState({ searchType: type });
    } else {
      type = this.state.searchType;
    }
    if (this.props.currentLocationId) {
      if (type === 'GET_ALL') {
        searchObj = {
          tag: this.state.searchTerm,
          locationid: this.props.currentLocationId,
          startwith: '',
          isactive: '',
        };
      } else if (type === 'GET_TRUE') {
        searchObj = {
          tag: this.state.searchTerm,
          locationid: this.props.currentLocationId,
          startwith: '',
          isactive: true,
        };
      } else {
        searchObj = {
          tag: this.state.searchTerm,
          locationid: this.props.currentLocationId,
          startwith: '',
          isactive: false,
        };
      }
    }
    // this.props.getPatientByTag(searchObj);
    let currentLocationId =  this.state.ShowClientsOfAllLocations ? '0' : searchObj.locationid,
      filter = 'Tags',
      searchValue = searchObj.tag,
      advancedFilter = `&startwith=${this.state.activeChar}&isActive=${searchObj.isactive}`,
      tagSearch = true;
    this.props.getPatientsByFilter(filter, searchValue, advancedFilter, currentLocationId, tagSearch, this.props.viewTeamClientsOnlyPermission);
  }


  componentWillMount() {
    // let searchObj = {
    //   filters: { TypeKey: 'ALL_CLIENT,BOTH' },
    // };
    // this.props.getPatientMasterTags(searchObj);
    // this.loadPatients('startwith', 'A');
    // this.props.getPatients('startwith', '');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.patientdata && this.props.patientdata !== nextProps.patientdata) {
      let patientdata = nextProps.patientdata.data;
      this.setState({ patientdata: patientdata });
    }
    if (nextProps.slideIndex === 1 && nextProps.slideIndex !== this.props.slideIndex) {
      let masterDataList = 'masterTagsforPatient';
      this.props.getPatientMasterTags(masterDataList);
      this.setState({ patientdata: [], activeChar: '' });
    }

  }

  handleChange(tags) {
    this.setState({ tags });
  }

  handleNewRequest = (input, values, noContent, label, data) => {
    this.props.tagSelect(true);
    this.setState({ searchTerm: '' });
    if (data && data.length) {
      let searchValues = [];
      data.forEach((selectedData, i) => {
        searchValues.push(selectedData.value);
      });
      this.setState({ searchTerm: searchValues.join(','), type: 'GET_TRUE' }, () => {
        if (this.state.searchTerm !== '') {
          this.loadPatients();
        }
      });
    } else {
      this.setState({ patientdata: [] });
    }
  };

  onClickAlphabet(e) {
    let char = e.target.id;
    this.setState({ activeChar: char }, () => {
      this.loadPatients();
    });
  }

  handleAdvanceSearchClick = () => {
    this.setState({ openAdvanceSearch: !this.state.openAdvanceSearch });

    if (this.state.openAdvanceSearch) {
      this.props.dispatch(change('ListPatientForm', 'ActiveClient', false));
      this.props.dispatch(change('ListPatientForm', 'InactiveClient', false));
      this.setState({ ActiveClient: false, InactiveClient: false },
        () => {
          this.loadAdvanceSearchFilters();
        });
    }
  }

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadAdvanceSearchFilters();
      });
  }

  loadAdvanceSearchFilters() {
    let type;
    if (this.state.ActiveClient === true && this.state.InactiveClient === true) {
      type = 'GET_ALL';
    } else if ((this.state.ActiveClient === true && this.state.InactiveClient === false) ||
      (this.state.ActiveClient === false && this.state.InactiveClient === false)) {
      type = 'GET_TRUE';
    } else if (this.state.ActiveClient === false && this.state.InactiveClient === true) {
      type = 'GET_FALSE';
    }

    this.setState({ type }, () => this.loadPatients());
  }

  renderLoading() {
    if (this.props.loading_searchTagsSidePanel || this.props.loading_patientTags) {
      return (
        <div className="full_loader top0">
          <div className="small-loader">
            <img src={SmallLoader} alt="" />
          </div>
        </div>
      );
    }
  }

  renderAlphabets() {
    let alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    return alphabets.map((char, index) => {
      return (
        <div
          key={index}
          id={char}
          onClick={this.onClickAlphabet}
          className={this.state.activeChar === char ? 'active' : ''}>
          {char}</div>
      );
    });
  }

  getPatientById(e, patientId) {
    e.preventDefault();
    this.props.getPatientDetailsById(patientId);
  }

  hideSidebar(e, url, patientId) {
    e.preventDefault();
    history.push(url + `${patientId}`);
    this.props.toggleSwitch();
  }

  onPatientClick(e, url, patientId) {
    e.preventDefault();
    // this.props.showPatientsSubMenus(true);
    if (this.props.viewProfileSmryPermission) {
      this.hideSidebar(e, url, patientId);
    } else {
      patientId = base64Decode(patientId);
      this.props.getPatientDetailsById(patientId);
      this.props.toggleSwitch();
    }
  }


  // handlefavourites(patientId) {
  //   let userId = this.props.loginUserInfo.userID;
  //   this.props.addFavouriteAction(patientId, userId);
  // }

  renderPatients() {

    if (this.state.patientdata.length === 0) {
      return (
        <ListItem className="clientitem"
          primaryText="Please select tags to view cilent(s)."
          insetChildren={true}
        ></ListItem>
      );
    }

    if (this.state.patientdata) {
      return this.state.patientdata.map((patient) => {
        let { patientId, firstName, lastName, mrn, dob, photoThumbnailPath, isActive, isBlock } = patient;
        let patId = base64Encode(`${patientId}`);
        let name = `${firstName} ${lastName}`;
        name = name.trim();
        return (
          <NavLink
            key={patientId}
            onClick={(e) => this.onPatientClick(e, `/client/profile/`, patId)}
            to={this.props.viewProfileSmryPermission ? `/client/profile/${patId}` : ''}>
            <ListItem className="clientitem"
              primaryText={name}
              secondaryText={
                <span className="searchitem">
                  <font>{`Client ID: ${mrn}`}</font>
                  <font>{`D.O.B : ${showFormatedDate(dob)}`}</font>
                </span>
              }
              insetChildren={true}
            >
              {/* <span className={isActive ? 'clientsearch_img' : 'clientsearch_img inactive'}>
              <Avatar src={photoThumbnailPath || user1}/>
              <i className="fa fa-circle" aria-hidden="true"></i>
            </span> */}

              {isActive && isBlock ?
                <span className='clientsearch_img activec lock'>
                  {photoThumbnailPath ? <Avatar src={photoThumbnailPath} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
                : null}

              {isActive && isBlock === false ?
                <span className='clientsearch_img activec'>
                  {photoThumbnailPath ? <Avatar src={photoThumbnailPath} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-circle" aria-hidden="true"></i>
                </span>
                : null}

              {isActive === false && isBlock ?
                <span className='clientsearch_img inactive lock'>
                  {photoThumbnailPath ? <Avatar src={photoThumbnailPath} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
                : null}

              {isActive === false && isBlock === false ?
                <span className='clientsearch_img inactive'>
                  {photoThumbnailPath ? <Avatar src={photoThumbnailPath} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  <i className="fa fa-circle" aria-hidden="true"></i>
                </span>
                : null}

            </ListItem></NavLink>
        );
      });
    }
  }

  render() {
    return (
      <div>
        {/*  <div>
          <TagsInput onlyUnique={true} value={this.state.tags} onChange={this.handleChange} />
        </div>*/}
        <div>
          <div className="tagselect">
            <Field
              name="Tags"
              label="Tags"
              handleNewRequest={this.handleNewRequest}
              options={this.props.masterTags}
              component={renderAutoCompleteMultipleSelection} />
          </div>
          <IconButton className="s_filter" onClick={this.handleAdvanceSearchClick}>
            <i className="fa fa-filter" aria-hidden="true"></i>
          </IconButton>
          {this.state.openAdvanceSearch ?
            <div className="filterbox" >
              <div className="row">
                <div className="col-12 filterhead">
                  Advance Search Filter <i className="fa fa-times" aria-hidden="true" onClick={this.handleAdvanceSearchClick}></i>
                </div>
                <div className="col-12">
                  <Field
                    name="ActiveClient"
                    label="Include active clients only"
                    component={renderCheckBox}
                    onChange={(e) => this.handleAdvanceFilterCheck(e, 'ActiveClient')}
                    style={stylescss.checkbox}
                  />
                </div>
                <div className="col-12">
                  <Field
                    name="InactiveClient"
                    label="Include inactive clients only"
                    component={renderCheckBox}
                    onChange={(e) => this.handleAdvanceFilterCheck(e, 'InactiveClient')}
                    style={stylescss.checkbox}
                  />
                </div>
                <div className="col-12">
                <Field
                  name="ShowClientsOfAllLocations"
                  label="Clients in all locations"
                  component={renderCheckBox}
                  onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowClientsOfAllLocations')}
                  style={stylescss.checkbox}
                />
              </div>
              </div>
            </div>
            :
            ''
          }
          <div >

          </div>
        </div>
        <div className="clearfix"></div>
        <div className="tagclient">
          <div className="clientalpha">
            {this.renderAlphabets()}
          </div>
          <div className="clientlist">
            {this.renderLoading()}
            <List>
              {this.renderPatients()}
            </List>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {

  // Start For Role Permission
  let userScreenPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);

  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let viewProfileSmryPermission = hasDefaultAccess ? true : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_PROFILE')[0].permission : false;
  let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0].permission : false;
  // End For Role Permission

  return {
    loading_patientTags: state.patient.loading_patientTags,
    patientdata: state.patient.get_patient_ByFilterWithTags,
    masterTags: (state.patient.patientMasterTags && state.patient.patientMasterTags.masterTagsforPatient) || [],
    loginUserInfo: state.login.loginUserInfo,
    loading_searchTagsSidePanel: state.patient.loading_searchTagsSidePanel,
    currentLocationId: state.login.currentLocationId,
    viewProfileSmryPermission: viewProfileSmryPermission,
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
  };
}
ListPatient = reduxForm({
  form: 'ListPatientForm',
  enableReinitialize: true,
})(ListPatient);
export default connect(mapStateToProps, { newPatient, getPatients, getAllPatients, getPatientByTag, getPatientsByFilter, getPatientDetailsById, getPatientsByFirstCharacter, getPatientMasterTags })(ListPatient);



// WEBPACK FOOTER //
// ./src/modules/patients/list_patient.js